import { __rest } from "tslib";
import { withWixStyle } from './useWixStyle';
import { withOneAppStyle } from './useOneAppStyle';
export var themeStrategy = function (_a, experiments, isBmPlatform) {
    var _b;
    if (_a === void 0) { _a = {}; }
    var useWixStyles = _a.useWixStyles, useOneAppStyles = _a.useOneAppStyles, rest = __rest(_a, ["useWixStyles", "useOneAppStyles"]);
    if (experiments === void 0) { experiments = {}; }
    if (isBmPlatform === void 0) { isBmPlatform = false; }
    var isWithWixStylesEnabled = (_b = experiments === null || experiments === void 0 ? void 0 : experiments.withWixStyles) === null || _b === void 0 ? void 0 : _b.enabled;
    var shouldUseWixStyles = useWixStyles !== null && useWixStyles !== void 0 ? useWixStyles : (isBmPlatform && !!isWithWixStylesEnabled);
    return useOneAppStyles ? withOneAppStyle(rest) : shouldUseWixStyles ? withWixStyle(rest) : rest;
};
//# sourceMappingURL=themeStrategy.js.map